import { jsx } from "react/jsx-runtime";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import { validateTidalLicense } from "../../base/index.js";
function ZoomIn(props) {
  return /* @__PURE__ */ jsx(
    ZoomInIcon,
    {
      "data-testid": "ZoomIn",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ZoomIn",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
ZoomIn.tidalIconMeta = {
  categories: "map,location,time",
  name: "ZoomIn"
};
validateTidalLicense();
export {
  ZoomIn
};
//# sourceMappingURL=ZoomIn.js.map
